/**
 * BAMBOOVE — "RECENTLY VIEWED": phan JS  (12/10/2026 · phieu 54)
 * ---------------------------------------------------------------------------
 * File nay lam 2 viec, KHONG goi API / KHONG dung app / KHONG thu vien:
 *
 *   1) GHI NHO: dang o trang san pham => luu handle vao localStorage
 *      (danh sach 'bamboove-da-xem', moi nhat dung dau, toi da 12, khong trung).
 *      Nguon handle: thuoc tinh `data-bb-rv-now` (khoi Liquid in ra khi co `product`).
 *
 *   2) HIEN LAI: sap xep lai cac the co san theo dung thu tu khach da xem,
 *      an cac the khong nam trong danh sach. Chua xem gi => AN ca khoi.
 */
(function () {
  'use strict';

  var KHOA = 'bamboove-da-xem';
  var TOI_DA = 12;
  var TOI_DA_HIEN = 8;
  /* PHIẾU 72 (16/10/2026): khoá MỚI lưu ĐỦ dữ liệu (mã + tên + ảnh + giá) để giỏ trượt
     vẽ được thẻ “Recently viewed” NGAY (cột trái, thẻ to) — không phải chờ mạng. */
  var KHOA_V2 = 'bamboove-da-xem-v2';
  var TOI_DA_V2 = 8;

  function doc() {
    try {
      var raw = localStorage.getItem(KHOA);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function ghi(arr) {
    try {
      localStorage.setItem(KHOA, JSON.stringify(arr));
    } catch (e) {
      /* trinh duyet chan localStorage (che do rieng tu) */
    }
  }

  function ghiNho(handle) {
    if (!handle) return;
    var arr = doc();
    var moi = [handle];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] !== handle && moi.length < TOI_DA) moi.push(arr[i]);
    }
    ghi(moi);
  }

  function hienLai(khoi) {
    var daXem = doc();
    if (!daXem.length) return; // de nguyen `hidden`

    var gioiHan = parseInt(khoi.getAttribute('data-bb-rv-gioi-han'), 10);
    if (isNaN(gioiHan) || gioiHan <= 0) gioiHan = TOI_DA_HIEN;

    var dangXem = khoi.getAttribute('data-bb-rv-now') || '';
    var ds = khoi.querySelectorAll('[data-bb-rv-card]');
    if (!ds.length) return;

    // Gom the theo handle
    var theTheoHandle = {};
    for (var i = 0; i < ds.length; i++) {
      theTheoHandle[ds[i].getAttribute('data-handle')] = ds[i];
    }

    // An het truoc
    for (var j = 0; j < ds.length; j++) ds[j].hidden = true;

    // Hien + sap lai theo thu tu da xem (bo qua san pham dang mo)
    var list = khoi.querySelector('.bamboove-rv__list');
    var soHien = 0;
    for (var k = 0; k < daXem.length && soHien < gioiHan; k++) {
      var h = daXem[k];
      if (h === dangXem) continue;
      var the = theTheoHandle[h];
      if (!the) continue;
      the.hidden = false;
      if (list) list.appendChild(the);
      soHien++;
    }

    if (soHien > 0) khoi.hidden = false;
  }

  /** PHIẾU 72 (16/10/2026) — lưu ĐỦ dữ liệu sản phẩm đang xem (không chỉ mã).
   *  Vì sao: giỏ trượt cần vẽ thẻ “Recently viewed” NGAY (cột trái, thẻ to) mà không
   *  phải chờ mạng. Đọc thẳng từ DOM trang sản phẩm (tên · ảnh · giá). */
  function ghiNhoDayDu() {
    var el = document.querySelector('[data-bb-rv-now]');
    if (!el) return;
    var handle = el.getAttribute('data-bb-rv-now');
    if (!handle) return;

    var h1 = document.querySelector('.bb-pdp__title') || document.querySelector('h1');
    var anh = document.querySelector('.bb-pdp__track img') || document.querySelector('img[src*="/cdn/shop/"]');
    var gia = document.querySelector('[data-bb-price]');

    var ban = {
      handle: handle,
      title: h1 ? h1.textContent.replace(/\s+/g, ' ').trim().slice(0, 120) : handle,
      url: location.pathname,
      image: anh ? (anh.currentSrc || anh.src || '') : '',
      price: gia ? gia.textContent.replace(/\s+/g, ' ').trim() : '',
      ts: Date.now()
    };

    try {
      var raw = localStorage.getItem(KHOA_V2);
      var arr = raw ? JSON.parse(raw) : [];
      if (Object.prototype.toString.call(arr) !== '[object Array]') arr = [];
      var dsMoi = [ban];
      for (var i = 0; i < arr.length && dsMoi.length < TOI_DA_V2; i++) {
        if (arr[i] && arr[i].handle && arr[i].handle !== handle) dsMoi.push(arr[i]);
      }
      localStorage.setItem(KHOA_V2, JSON.stringify(dsMoi));
    } catch (e) {
      /* trinh duyet chan localStorage */
    }
  }

  function chay(root) {
    var pham = root || document;
    if (!pham.querySelectorAll) return;

    // 1) Ghi nho san pham dang xem (chi khi co thuoc tinh nay)
    var moi = pham.querySelector('[data-bb-rv-now]');
    if (moi) {
      ghiNho(moi.getAttribute('data-bb-rv-now'));
      ghiNhoDayDu(); /* PHIẾU 72: luu them ten + anh + gia */
    }

    // 2) Hien lai cac the da xem
    var ds = pham.querySelectorAll('[data-bb-rv]');
    for (var i = 0; i < ds.length; i++) hienLai(ds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      chay(document);
    });
  } else {
    chay(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    chay(e.target);
  });
})();
